import React from 'react';
import MenuIcon from '@material-ui/icons/Menu';
import {
  Toolbar,
  IconButton,
  Typography,
  AppBar as MaterialUIAppBar,
} from '@material-ui/core';
import clsx from 'clsx';
import { NavBarProps } from 'models';
import useStyles from './style';

const AppBar: React.FC<NavBarProps> = (props) => {
  const { isOpen, onClick: handleDrawerState } = props;
  const classes = useStyles();

  return (
    <MaterialUIAppBar
      position='fixed'
      className={clsx(classes.appBar, {
        [classes.appBarShift]: isOpen,
      })}
    >
      <Toolbar>
        <IconButton
          color='inherit'
          aria-label='open drawer'
          edge='start'
          onClick={handleDrawerState}
          className={clsx(classes.menuButton, {
            [classes.hide]: isOpen,
          })}
        >
          <MenuIcon />
        </IconButton>
        <Typography variant='h6' noWrap>
          HUSO on the GO
        </Typography>
      </Toolbar>
    </MaterialUIAppBar>
  );
};

export default AppBar;
